import type {DocumentDirection, VatCode} from "../generated/enums.ts";

export type VatDirection = Exclude<DocumentDirection, 'other'>;

export const VAT_CODE_RATE_LABELS: Record<VatCode, string> = {
    sales_high_rate: "21%",
    sales_low_rate: "9%",
    sales_zero_rate: "0%",
    sales_reverse_charge_domestic: "Verlegd",
    sales_intra_eu: "EU 0%",
    sales_export_outside_eu: "Export 0%",
    purchase_high_rate: "21%",
    purchase_low_rate: "9%",
    purchase_zero_rate: "0%",
    purchase_reverse_charge_domestic: "Verlegd",
    purchase_intra_eu: "EU 0%",
    purchase_import_outside_eu: "Invoer",
};

export function vatRateLabel(basisPoints: number): string {
    return `${(basisPoints / 100).toLocaleString("nl-NL", {maximumFractionDigits: 2})}%`;
}

export interface VatCodeOption {
    value: VatCode;
    label: string;
}

export const SALES_VAT_CODE_OPTIONS: VatCodeOption[] = [
    { value: "sales_high_rate", label: "Hoog tarief (21%)" },
    { value: "sales_low_rate", label: "Laag tarief (9%)" },
    { value: "sales_zero_rate", label: "Nultarief (0%)" },
    { value: "sales_reverse_charge_domestic", label: "Btw verlegd (Binnenland)" },
    { value: "sales_intra_eu", label: "Binnen EU (Intracommunautaire levering)" },
    { value: "sales_export_outside_eu", label: "Buiten EU (uitvoer / export)" },
];

export const PURCHASE_VAT_CODE_OPTIONS: VatCodeOption[] = [
    { value: "purchase_high_rate", label: "Hoog tarief (21%)" },
    { value: "purchase_low_rate", label: "Laag tarief (9%)" },
    { value: "purchase_zero_rate", label: "Nultarief (0%)" },
    { value: "purchase_reverse_charge_domestic", label: "Btw verlegd (Binnenland)" },
    { value: "purchase_intra_eu", label: "Binnen EU (Intracommunautaire verwerving)" },
    { value: "purchase_import_outside_eu", label: "Buiten EU (Invoer / Import)" },
];

export function getVatCodeOptions(direction: VatDirection): VatCodeOption[] {
    return direction === 'sales_invoice'
        ? SALES_VAT_CODE_OPTIONS
        : PURCHASE_VAT_CODE_OPTIONS;
}

export function getDefaultDirection(signedAmount: number): VatDirection {
    return signedAmount < 0
        ? 'purchase_invoice'
        : 'sales_invoice';
}
